export const roleValues = {
    admin: 'admin',
    dataProtectionOfficer: 'data-protection-officer',
    projectCoordinator: 'project-coordinators',
    supervisor: 'supervisor',
}
export const roles = [
    {
        label: "Admin",
        value: roleValues.admin,
    },
    {
        label: "Data Protection Officer",
        value: roleValues.dataProtectionOfficer,
    },
    {
        label: "Project Coordinators",
        value: roleValues.projectCoordinator,
    },
    {
        label: "Supervisor",
        value: roleValues.supervisor,
    }
]